/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Composables
import { createApp } from 'vue'

// Components
import App from './App.vue'

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful');
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

// Динамически загружаем плагины и монтируем приложение
const initApp = async () => {
  // Ждём загрузки Telegram Web App (или таймаута)
  if (window.TelegramReady) {
    await window.TelegramReady;
  }
  
  // Создаем приложение
  const app = createApp(App)
  
  const { registerPlugins } = await import('@/plugins')
  registerPlugins(app)
  app.mount('#app')
}

// Запускаем инициализацию
initApp().catch(console.error)
